import { f as r } from "./function-uncurry-this.js";
var t = r({}.toString),
  n = r("".slice),
  o = function o(r) {
    return n(t(r), 8, -1);
  };
export { o as c };